// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Hidable from "../../components/Hidable"
import * as strings from "../../strings"
import Input from "react-toolbox/lib/input"
import Dialog from "react-toolbox/lib/dialog"
import Division from "../../components/Division"
import DatePicker from "../../components/DatePicker"
import Dropdown from "react-toolbox/lib/dropdown"
import { Button } from "react-toolbox/lib/button"
import Autocomplete from "react-toolbox/lib/autocomplete"
import { connect } from "react-redux"
import * as _ from "lodash"
import { toastr } from "react-redux-toastr"

// TODO: Fix this class name
class Execution extends Component {

  props: {
    execution: any,
    isRequestExecution: boolean,
    courts: any,
    onChange: () => any,
    expanded?: boolean,
    suggestions: any,
    onToggle?: () => any,
    debt: any,
    scheduleJob: ( string, any ) => any,
    updateSuggestion: any,
  }

  state = {
    missingFields: undefined,
    date: undefined,
    confirmDialog: false,
  }

  handleChange = ( name, isToRound ) => value => {
    return this.props.onChange && this.props.onChange( {
      ...this.props.execution,
      [ name ]: !_.isEqual( value, "" ) ? isToRound ? _.round( value, 2 ) : value : null,
    } )
  }

  canShowConfirmDialog = missingFields => {
    return _.isEqual( _.compact( _.values( missingFields ) ).length, 0 )
  }

  pickCitiusFields = execution => _.pick( execution, [
    "executionNumber", "purpose", "type", "endOfExecution", "executiveTitle",
    "feReference", "agentNumber", "agentRetentionModel", "iban", "justiceTax",
    "duc", "paymentDescription", "feOppositionDate", "capitalValue",
    "interestUntilLitigation", "sentenceDate", "briefAccount", "settlementOne",
    "settlementTwo", "interestFromRiUntilExecution", "interestCompulsory",
    "totalInterest", "totalValue",
  ] )

  getCitiusMissingFields = () => {
    const citiusFields = this.pickCitiusFields( this.props.execution )

    let missingFields = {}
    _.keys( citiusFields ).forEach( fieldKey => {
      const fieldValue = citiusFields[ fieldKey ]
      const isValid = _.isNull( fieldValue ) || _.isUndefined( fieldValue )
      const value = isValid ? strings.errorMessages.missingField : false

      missingFields = _.assign( missingFields, { [ fieldKey ]: value } )
    } )

    let court
    if ( _.isNull( this.props.execution.court ) ) {
      court = strings.errorMessages.missingField
    } else if ( !this.props.execution.court.isCitius ) {
      court = strings.errorMessages.notACitiusCourt
    } else {
      court = false
    }

    missingFields = {
      ...missingFields,
      court,
    }

    return missingFields
  }

  handleCitius = () => {
    if ( !this.props.isRequestExecution ) {
      toastr.error( "Por favor guarde o processo primeiro." )
      return Promise.reject()
    }
    const missingFields = this.getCitiusMissingFields()

    return this.setState( {
      missingFields,
      confirmDialog: this.canShowConfirmDialog( missingFields ),
    } )
  }

  handleToggle = () => {
    this.setState( {
      confirmDialog: !this.state.confirmDialog,
    } )
  }

  renderTable = ( tableInfo, isDebtor ) => {
    return <table className={style.tableCss}>
      <thead>
        <tr>
          <th className={style.tableTitle}><b>{strings.generalStrings.inputs}</b></th>
          <th className={style.tableTitle}><b>{strings.generalStrings.information}</b></th>
        </tr>
      </thead>
      <tbody>
        {_.entries( tableInfo ).map( ( field, i ) =>
          <tr key={i}>
            <td className={style.tdTitle}>{isDebtor ? strings.generalStrings[ field[ 0 ] ] : strings.execution[ field[ 0 ] ]}</td>
            <td className={style.tdTitle}>{field[ 1 ]}</td>
          </tr> )}
      </tbody>
    </table>
  }

  renderDialogInfo = () => {
    const { debt } = this.props


    if ( !( debt && debt.debtDebtors ) ) {
      return <div/>
    }

    const citiusExec = this.pickCitiusFields( this.props.execution )
    const mainDebtor = debt.debtDebtors.find( debtDebtor => debtDebtor.debtor.id === debt.idDebtor )
    const mainDebtorInfo = _.omit( mainDebtor.debtor.contact, [ "capitalStock", "id" ] )

    return (
      <div className={style.insideDialog}>
        <div className={style.blueHeader}/>
        <div className={style.table}>
          <Division title={strings.generalStrings.debtor.toUpperCase()}/>
          {this.renderTable( mainDebtorInfo, true )}
          <Division title={strings.generalStrings.citius.toUpperCase()}/>
          {this.renderTable( citiusExec, false )}
        </div>
      </div>
    )
  }

  citiusSubmit () {
  }

  renderButtons () {
    const citiusButtonDisabled = !_.get( this.props, "execution.isActive", false ) ||
      _.get( this.props, "execution.litigationExecutions.length" ) !== 1

    return (
      <div className={style.buttonsInterface}>
        <Button
          icon="add"
          raised
          primary
          disabled={citiusButtonDisabled}
          onClick={this.handleCitius}>
          {strings.generalStrings.submitToCitius}
        </Button>
        <Button icon="add" raised primary>{strings.generalStrings.sendInterpolingLetter}</Button>
      </div>
    )
  }

  render () {
    if ( _.isEqual( this.props.suggestions, {} ) ) {
      return <div/>
    }

    const isActiveSource = [
      { value: true, label: "Ativo" },
      { value: false, label: "Inativo" },
    ]

    if ( _.isEqual( this.props.suggestions, {} ) ) {
      return <div/>
    }


    const agentRetentionModels = _.get( this.props.suggestions, "AgentRetentionModelEnum", [] )
      .map( retentionModel => ( {
        value: retentionModel.name,
        label: retentionModel.name,
      } ) )

    const courtSource = _.get( this.props, "suggestions.courts", [] )
      .filter( court => court.isCitius )
      .reduce( ( acc, court ) => ( {
        ...acc,
        [ court.id ]: court.name,
      } ), {} )

    // If idCourt points to a non citius court, we would show the id.
    // this isn't very user friendly. so if the court isn't a citius
    // court we are going to change the value to show the court name
    const courtValue = !courtSource[ this.props.execution.idCourt ] ?
      _.get( _.find( this.props.courts, { id: this.props.execution.idCourt } ), "name" ) :
      this.props.execution.idCourt

    return (
      <Hidable
        title={strings.generalStrings.executionDetails.toUpperCase()}
        expanded={this.props.expanded}
        onToggle={this.props.onToggle}
      >
        <Dialog
          className={style.dialogBoxFormat}
          actions={[
            { label: strings.generalStrings.cancel, onClick: this.handleToggle },
            { label: strings.generalStrings.submit, onClick: this.citiusSubmit.bind( this ) },
          ]}
          active={this.state.confirmDialog}
          onEscKeyDown={this.handleToggle}
          onOverlayClick={this.handleToggle}
          type="fullscreen"
        >
          {this.renderDialogInfo()}
        </Dialog>
        <div className={style.backGround}>
          <Division title={strings.generalStrings.details.toUpperCase()}/>
          <div className={style.wrapper}>
            <Input
              label={strings.paymentAgreements.executionNumber}
              type="text"
              value={this.props.execution.executionNumber}
              error={_.get( this.state, "missingFields.executionNumber", false )}
              onChange={this.handleChange( "executionNumber", false )}
            />
            <Input
              label={strings.execution.purpose}
              error={_.get( this.state, "missingFields.purpose", false )}
              type="text"
              value={this.props.execution.purpose}
              onChange={this.handleChange( "purpose", false )}
            />
            <Input
              label={strings.execution.specie}
              error={_.get( this.state, "missingFields.type", false )}
              type="text"
              value={this.props.execution.type}
              onChange={this.handleChange( "type", false )}
            />
            <Input
              label={strings.execution.endOfExecution}
              error={_.get( this.state, "missingFields.endOfExecution", false )}
              type="text"
              value={this.props.execution.endOfExecution}
              onChange={this.handleChange( "endOfExecution" )}
            />
            <Input
              label={strings.execution.executiveTitle}
              error={_.get( this.state, "missingFields.executiveTitle", false )}
              type="text"
              value={this.props.execution.executiveTitle}
              onChange={this.handleChange( "executiveTitle", false )}
            />
            <Input
              label={strings.execution.feReference}
              error={_.get( this.state, "missingFields.feReference", false )}
              type="text"
              value={this.props.execution.feReference}
              onChange={this.handleChange( "feReference", false )}
            />
            <Input
              label={strings.execution.agentNumber}
              error={_.get( this.state, "missingFields.agentNumber", false )}
              type="text"
              value={this.props.execution.agentNumber}
              onChange={this.handleChange( "agentNumber", false )}
            />
            <Dropdown
              auto
              onChange={this.handleChange( "agentRetentionModel", false )}
              label={strings.execution.agentRetentionModel}
              error={_.get( this.state, "missingFields.agentRetentionModel", false )}
              type="text"
              value={this.props.execution.agentRetentionModel}
              source={agentRetentionModels}
            />
            <Input
              label={strings.execution.iban.toUpperCase()}
              error={_.get( this.state, "missingFields.iban", false )}
              type="text"
              value={this.props.execution.iban}
              onChange={this.handleChange( "iban", false )}
            />
            <Input
              label={strings.execution.justiceTax}
              error={_.get( this.state, "missingFields.justiceTax", false )}
              type="number"
              step={0.01}
              value={this.props.execution.justiceTax}
              onChange={this.handleChange( "justiceTax", true )}
            />
            <Input
              label={strings.execution.duc.toUpperCase()}
              error={_.get( this.state, "missingFields.duc", false )}
              type="text"
              value={this.props.execution.duc}
              onChange={this.handleChange( "duc", false )}
            />
            <Input
              label={strings.execution.paymentDescription}
              type="text"
              error={_.get( this.state, "missingFields.paymentDescription", false )}
              value={this.props.execution.paymentDescription}
              onChange={this.handleChange( "paymentDescription", false )}
            />
            <DatePicker
              error={_.get( this.state, "missingFields.feOppositionDate", false )}
              label={strings.execution.feOppositionDate}
              onChange={this.handleChange( "feOppositionDate", false )}
              value={ this.props.execution.feOppositionDate ? new Date( this.props.execution.feOppositionDate ) : undefined }
            />
            {/* <Input
              label={strings.execution.capitalInDebt}
              type="number"
              step={0.01}
              value={this.props.execution.capitalValue}
              onChange={this.handleChange( "capitalValue", true )}
            /> */}
            <Input
              label={strings.execution.interestUntilLitigation}
              error={_.get( this.state, "missingFields.interestUntilLitigation", false )}
              type="number"
              step={0.01}
              value={this.props.execution.interestUntilLitigation}
              onChange={this.handleChange( "interestUntilLitigation", true )}
            />
            <DatePicker
              error={_.get( this.state, "missingFields.sentenceDate", false )}
              label={strings.execution.sentenceDate}
              onChange={this.handleChange( "sentenceDate", false )}
              value={ this.props.execution.sentenceDate ? new Date( this.props.execution.sentenceDate ) : undefined }
            />
            <Dropdown
              auto
              onChange={this.handleChange( "isActive", false )}
              label={strings.execution.activeState}
              source={isActiveSource}
              value={this.props.execution.isActive}
            />
          </div>
          <Division title={strings.generalStrings.facts.toUpperCase()}/>
          <div className={style.wrapper}>
            <Input
              label={strings.execution.briefAccount}
              error={_.get( this.state, "missingFields.briefAccount", false )}
              type="text"
              multiline={true}
              value={this.props.execution.briefAccount}
              onChange={this.handleChange( "briefAccount", false )}
            />
            <Input
              label={strings.execution.settlementOne}
              error={_.get( this.state, "missingFields.settlementOne", false )}
              multiline={true}
              type="text"
              value={this.props.execution.settlementOne}
              onChange={this.handleChange( "settlementOne", false )}
            />
            <Input
              label={strings.execution.settlementTwo}
              error={_.get( this.state, "missingFields.settlementTwo", false )}
              multiline={true}
              type="text"
              value={this.props.execution.settlementTwo}
              onChange={this.handleChange( "settlementTwo", false )}
            />
          </div>
          <Division title={strings.paymentAgreements.court.toUpperCase()}/>
          <div className={style.courtWrapper}>
            <Autocomplete
              direction="down"
              multiple={false}
              label={strings.execution.court}
              onChange={this.handleChange( "idCourt", false )}
              source={courtSource}
              value={courtValue}
              error={_.get( this.state, "missingFields.court", false )}
            />
            <Input
              label={strings.paymentAgreements.section}
              type="text"
              value={this.props.execution.section}
              onChange={this.handleChange( "section", false )}
            />
            <Input
              label={strings.paymentAgreements.service}
              type="text"
              value={this.props.execution.service}
              onChange={this.handleChange( "service", false )}
            />
          </div>
          <Division title={strings.generalStrings.interestCalculation.toUpperCase()}/>
          <div className={style.wrapper}>
            <Input
              label={strings.execution.interestFromRiUntilExecution}
              error={_.get( this.state, "missingFields.interestFromRiUntilExecution", false )}
              type="number"
              step={0.01}
              value={this.props.execution.interestFromRiUntilExecution}
              onChange={this.handleChange( "interestFromRiUntilExecution", true )}
            />
            <Input
              label={strings.execution.interestCompulsory}
              error={_.get( this.state, "missingFields.interestCompulsory", false )}
              type="number"
              step={0.01}
              value={this.props.execution.interestCompulsory}
              onChange={this.handleChange( "interestCompulsory", true )}
            />
            <Input
              label={strings.execution.totalInterest.toUpperCase()}
              error={_.get( this.state, "missingFields.totalInterest", false )}
              type="number"
              step={0.01}
              value={this.props.execution.totalInterest}
              onChange={this.handleChange( "totalInterest", true )}
            />
            <Input
              label={strings.execution.totalValue}
              error={_.get( this.state, "missingFields.totalValue", false )}
              type="number"
              step={0.01}
              value={this.props.execution.totalValue}
              onChange={this.handleChange( "totalValue", true )}
            />
          </div>
          {this.renderButtons()}
        </div>
      </Hidable>
    )
  }
}
export default connect( store => ( { suggestions: store.suggestions } ) )( Execution )



// WEBPACK FOOTER //
// ./src/components/ExtraExecutionDetails/index.jsx